export const orderDetails = {
  header: "Suivre la commande",
  quote: "Offre",
  subHeader: "Détails",
  hasBeenShipped: "Cette commande a déjà été effectuée",
  orderSummary: "Résumé de la commande",
  labels: {
    address: "Adresse",
    amountTotal: "Montant total",
    billingAddress: "Adresse de facturation",
    cartSum: "Somme",
    city: "Ville",
    country: "Pays",
    createdAt: "Commandé(e)",
    deliveryAndProductionTime: "Délai de livraison total estimé",
    deliveryAndProductionTimeShort: "Délai de livraison total",
    // TODO: add translations
    deliveryDay: "Date de livraison prévue",
    deliveryTime: "Délai de livraison prévu",
    deliveryTimeShort: "Délai d'envoi prévu",
    email: "Adress e-mail",
    items: "Articles",
    name: "Nom",
    net: "net",
    net: "net",
    orderNumber: "Numéro de commande",
    orderStatus: "Statut de la commande",
    payment: "Paiement",
    paymentMethod: "Mode de paiement",
    positionPrice: "Prix total (sans frais de livraison)",
    productionTime: "Délai de production",
    quoteCreatedAt: "Demande",
    quoteNumber: "Numéro de l'offre",
    shippingAddress: "Adresse de livraison",
    shippingMethod: "Livraison",
    shippingPrice: "Frais de port",
    summary: "Résumé",
    summaryCaps: "RÉCAPITULATION",
  },
  businessDays: "0 jour ouvert | 1 jour ouvert | {n} jours ouverts",
  regularDays: "0 jour | 1 jour | {n} jours ",
  actions: {
    reOrder: "Commander à nouveau",
    payNow: "Payer maintenant",
    orderNow: "Commandez maintenant",
  },
  reOrderModal: {
    headline: "Voulez-vous commander à nouveau la commande {orderNumber} ?",
    nItems: "0 pièce | une pièce | {n} pièces",
  },
};
